var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drill',{attrs:{"title":"ドリル練習系","dummy_image":"/dummy/drill_practice.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }